var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('Reproductor',{attrs:{"msg":"Saludos y despedidas","audio2":"../mp3/PrimariaD/01PD.mp3","cover":"../img/4.jpg","name":"Primaria D - Lección #1"}}),_c('Buttons')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }